<template>
  <div class="preview-partner-profile h-100vh">
    <CCard >
      <CCardBody>
        <div class="preview-wrapper position-relative h-100vh">
          <!-- Placeholder -->
          <div v-if="!link" class="preview-placeholder">
            <div class="placeholder-content">
              🔗 No preview available
              <!-- <p>Please provide a valid link to preview</p> -->
            </div>
          </div>
          <iframe
            v-else
            :src="iframeSrc"
            frameborder="0"
            class="preview-frame"
          ></iframe>

        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
export default {
  name: "PreviewPartnerProfile",
  props: {
    link: {
      type: String,
    },
  },

  data() {
    return {
      iframeSrc: this.link || "",
    };
  },

  methods: {
    reload() {
      this.iframeSrc = this.link;
    },
  },
};
</script>

<style scoped>
.preview-wrapper {
  position: fixed;
  inset: 0;
  background: #fff;
  height: 70vh;
}

.preview-iframe {
  width: 100vw;
  height: 100vh;
  border: none;
}

.preview-toolbar {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.7);
  padding: 8px;
  border-radius: 6px;
}

.preview-toolbar button {
  color: white;
  background: transparent;
  border: 1px solid white;
  padding: 6px 10px;
  cursor: pointer;
}

/* placeholder */
.preview-placeholder {
  /* width: 100vw;
  height: 100vh; */
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f6f8;
  color: #666;
  height: 100%;
}

.placeholder-content {
  text-align: center;
  font-size: 18px;
}

.placeholder-content p {
  margin-top: 8px;
  font-size: 14px;
  color: #888;
}
</style>
